import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine';
import style from './block.module.scss';
import clsx from 'clsx';

const ImageTextColLeft = ({ smallMargin }) => {
    return (
        <BlockWrapper.ChildrenBlocks
            className={clsx(style.block, smallMargin && style.smallMargin)}
            gutenbergEditorConfig={{
                orientation: 'vertical',
                allowedBlocks: [
                    'core/heading',
                    'core/paragraph',
                    'core/image',
                    'core/list',
                    'smartfire/button',
                    'smartfire/highlight',
                    'smartfire/spacer',
                ],
                template: [['core/paragraph', {}]],
            }}
        />
    );
};

export default defineBlock({
    Block: ImageTextColLeft,
    smartProps: {},
    setup: {
        title: 'Colonne image et text gauche',
        parent: ['smartfire/image-text'],
    },
});
